import "./App.css";
import Menu from "./components/Menu";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/venues/:venueId/menu" element={<Menu />} />
      </Routes>
    </div>
  );
}

export default App;
